// Commercial Costs Data
export const commercialCostsData = {
  2024: {
    grossSales: 285.4,
    royalties: 14.27,
    sodiamFeesRegular: 4.56,
    sodiamFeesSpecial: 0.87,
    totalSodiamFees: 5.43,
    totalCommercialCosts: 19.70,
    netRevenueAfterCharges: 265.70,
    takeRatePercent: 6.9,
    regularStonesShare: 80,
    specialStonesShare: 20,
    budgetCommercialCosts: 20.5,
    budgetVariance: -3.9,
  },
  2025: {
    grossSales: 250.0,
    royalties: 12.5,
    sodiamFeesRegular: 4.00,
    sodiamFeesSpecial: 0.87,
    totalSodiamFees: 4.87,
    totalCommercialCosts: 21.73,
    netRevenueAfterCharges: 291.07,
    takeRatePercent: 6.95,
    regularStonesShare: 80,
    specialStonesShare: 20,
    budgetCommercialCosts: 22.0,
    budgetVariance: -1.2,
  },
  2026: {
    grossSales: 328.5,
    royalties: 16.43,
    sodiamFeesRegular: 5.26,
    sodiamFeesSpecial: 1.15,
    totalSodiamFees: 6.41,
    totalCommercialCosts: 22.84,
    netRevenueAfterCharges: 305.66,
    takeRatePercent: 6.95,
    regularStonesShare: 80,
    specialStonesShare: 20,
    budgetCommercialCosts: 23.5,
    budgetVariance: -2.8,
  },
};
